import React, { useState } from "react";
import logo from "../../assets/images/ambu-medik.png";
import { ToastContainer, toast } from "react-toastify";
import styles from "./signin.module.css";
import { API_URL } from "../../constant";
import { useNavigate } from "react-router-dom";
import { login } from "../../api";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/auth/authActions";
import { setAuthUserData } from "../../localStorage";
import PasswordInput from "../utils/passwordInput/passwordInput";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { syncFCMTokenIfLoggedIn } from "../../utils/fcmSync";

const Signin = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginAuth = async (e) => {
    e.preventDefault();

    // Procesar solo una solicitud de inicio de sesión a la vez
    if (isSubmitting) return;

    setIsSubmitting(true);
    const toastId = toast.info(t("login_in_process"), {
      theme: "colored",
      autoClose: false,
    });

    try {
      const response = await login({ email, password });
      dispatch(loginUser(response.data));
      setAuthUserData(response.data);
      // Solicitar permiso y obtener el token FCM solo si el permiso no ha sido denegado
      // (Notification no existe en algunos navegadores, p. ej. Safari en iOS fuera de una PWA)
      const permission =
        "Notification" in window ? await Notification.requestPermission() : "denied";
      if (permission === "granted") {
        // La respuesta del login es plana: los datos del usuario están en response.data
        await syncFCMTokenIfLoggedIn(response.data);
      } else {
        console.warn("Permiso de notificación denegado.");
      }

      toast.dismiss();
      navigate("/dashboard");
    } catch (error) {
      // Error de conexión con el servidor
      if (error.message === "Network Error") {
        toast.update(toastId, {
          type: "error",
          render: t("connection_failed"),
          theme: "colored",
          autoClose: 3000,
        });
        // Error de permisos
      } else if (
        error?.response?.data?.detail ===
        "No tienes permiso para acceder al back office"
      ) {
        toast.update(toastId, {
          type: "error",
          render: t("login_permissions_denied"),
          theme: "colored",
          autoClose: 3000,
        });
        // Error genérico para los demás fallos al autenticarse
      } else {
        toast.update(toastId, {
          type: "error",
          render: t("login_failed"),
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* <!-- login page start--> */}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img src={logo} alt="" />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4 className={styles.loginTitle}>{t("login")}</h4>
                        </div>
                        <form className="theme-form" onSubmit={loginAuth}>
                          <div className="form-group">
                            <label className="col-form-label pt-0">
                              {t("email")}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              name="email"
                              required
                              placeholder={t("email_example")}
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="form-group">
                            <div className={styles.password}>
                              <label className="col-form-label">
                                {t("password")}
                              </label>
                              <a
                                // Navegar a las vistas de recuperación de contraseña implementadas en el backend
                                href={`${API_URL}accounts/password-reset/`}
                                className={styles.passwordForgotten}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("password_reset")}
                              </a>
                            </div>
                            <PasswordInput
                              hideLabel
                              onChange={(e) => setPassword(e.target.value)}
                              value={password}
                            />
                          </div>
                          {/* <div className="checkbox p-0">
                            <input id="checkbox1" type="checkbox" />
                            <label htmlFor="checkbox1">{REMEMBER_ME}</label>
                          </div> */}
                          <div
                            className={`${styles.loginBtn} form-group form-row mt-3 mb-0 d-grid`}
                          >
                            <button className="btn btn-primary" type="submit">
                              {t("login")}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <footer
                      class="text-center bg-white"
                      style={{ position: "absolute", width: "100%" }}
                    >
                      <div class="row d-flex justify-content-center align-items-center">
                        <div class="col-md-12 col-lg-12">
                          <p class="text-body-secondary fw-medium mb-1">
                            {i18next.t("copyright")}
                            <a
                              href="https://www.idoogroup.com/"
                              rel="noreferrer"
                              class="text-decoration-none fw-bold transition"
                              target="_blank"
                            >
                              IdooGroup
                            </a>
                          </p>
                        </div>
                      </div>
                    </footer>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer closeOnClick autoClose={3000} theme="light" />
          {/* <!-- login page end--> */}
        </div>
      </div>
    </div>
  );
};

export default Signin;
